import { createAction } from "redux-actions";

import {
  WEBBOT_CLEAR_WAITS,
  WEBBOT_HIDE_WAITS,
  WEBBOT_SET_IS_TYPING,
  WEBBOT_SHOW_EVERYTHING_BEFORE_WAIT,
  WEBVIEW_DISABLED_INPUT,
} from "actions/const";
import { messageFrom } from "constants";
import { getFirstPendingWait } from "reducers/webbot";
import { getIsSkipUserInput } from "reducers/webview";
import { WEBBOT_MESSAGE_RECEIVED_FROM_SDK } from "../const";

let timeout = null;

const setIsTyping = createAction(WEBBOT_SET_IS_TYPING);
const hideWaits = createAction(WEBBOT_HIDE_WAITS);
const messageReceivedFromSdk = createAction(WEBBOT_MESSAGE_RECEIVED_FROM_SDK);
const showAllMessagesBeforeNextWait = createAction(
  WEBBOT_SHOW_EVERYTHING_BEFORE_WAIT
);
const isInputDisabled = createAction(WEBVIEW_DISABLED_INPUT);
const clearWaits = createAction(WEBBOT_CLEAR_WAITS);

const handleMessageVisibility =
  ({ isHumanMessage }) =>
  (dispatch, getState) => {
    if (timeout !== null || isHumanMessage) return;
    const nextWait = getFirstPendingWait(getState());
    dispatch(showAllMessagesBeforeNextWait());
    if (nextWait) {
      dispatch(setIsTyping(true));
      timeout = setTimeout(() => {
        timeout = null;
        dispatch(handleMessageVisibility({ isHumanMessage }));
      }, nextWait.get("wait"));
    } else {
      timeout = null;
      const skipUserInput = getIsSkipUserInput(getState());
      if (!skipUserInput) {
        dispatch(isInputDisabled(false));
      }
      dispatch(setIsTyping(false));
    }
  };

const handleClearWaits = () => dispatch => {
  clearTimeout(timeout);
  timeout = null;
  dispatch(setIsTyping(false));
  dispatch(clearWaits());
};

export default ({ data, functions }) => {
  const { dispatch } = functions;
  const { payload } = data;

  dispatch(messageReceivedFromSdk(payload));

  const { message } = payload;
  const isHumanMessage = message.from === messageFrom.human;
  if (isHumanMessage) {
    dispatch(handleClearWaits());
    dispatch(setIsTyping(true));
  }

  if (window.noDelayMode) {
    dispatch(hideWaits());
  }

  dispatch(handleMessageVisibility({ isHumanMessage }));
};
